import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// Form-only helpers that drive other fields; AdvInstanceFilterInput rejects them.
const FORM_ONLY_KEYS = [
  "checkExcludeUnlocatedShipments",
  "checkSiteManaged",
  "control",
  "previousRef",
  "temporaryRelease",
];

const toInstanceFilter = values =>
  Object.fromEntries(
    Object.entries(
      convertToFilter({
        values,
        filterKeys: ["tab"],
        skipKeys: ["limit", "offset"],
      }),
    ).filter(([key]) => !FORM_ONLY_KEYS.includes(key)),
  );

// observable store
const instanceFilterStore = makeObservable({});
const instanceNavigationStore =
  createSearchResultNavigationStore(instanceFilterStore);

const filterFormStore = createFilterFormStore(
  "instance",
  instanceFilterStore,
  instanceNavigationStore,
  { toFilter: toInstanceFilter },
);

const useInstanceFilters = onSubmit => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        artistRef: { operator: "like" },
        limit: 50,
        offset: 0,
        statusId: { operator: "in" },
        tab: "consignments",
        sort1: { operator: "ASC" },
        sort2: { operator: "ASC" },
        sort3: { operator: "ASC" },
        _condition: { statusId: { operator: "in" } },
        _edition: {
          _artwork: {
            categoryId: { operator: "in" },
            classId: { operator: "eq" },
            medium: { operator: "like" },
            series: { operator: "like" },
            title: { operator: "like" },
          },
          number: {
            operator: "eq",
          },
        },
      },
      onSubmit: values => {
        if (onSubmit) {
          onSubmit(values);
        }
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    // convert formik values to filter and update store
    instanceFilterStore.set(toInstanceFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  instanceFilterStore,
  instanceNavigationStore,
  toInstanceFilter,
  useInstanceFilters,
};
